export const sexIdentityOptions = [
    { translationId: 'insuranceForm:insurance_form.sex.male', value: 'M' },
    { translationId: 'insuranceForm:insurance_form.sex.female', value: 'F' },
    { translationId: 'insuranceForm:insurance_form.sex.unspecified', value: 'U' },
];
